import React, { useEffect, useState } from "react";
import { NotRelevantTag } from "../helpers/Enums";
import { TagProps } from "../typings/tag";
import Tag from "./Tag";
import NiceModal from "@ebay/nice-modal-react";

export interface EditTagsQuestionProps {
  onSave: (tags: number[]) => void;
  title: string | undefined;
  subtitle: string | undefined;
  tags: TagProps[];
  buttonText: string;
  selectedTagsValue: number[] | undefined;
  questionMaxAsnwer: number;
  questionMinAsnwer: number;
  skipButtonLink?: string;
  showCanPickMoreThanOneText?: boolean;
  isMandatoryQuestion?: boolean;
  questionId?: number;
}

const EditTagsQuestion = ({
  onSave,
  title,
  subtitle,
  buttonText,
  tags,
  selectedTagsValue,
  questionMaxAsnwer,
  questionMinAsnwer,
  skipButtonLink,
  showCanPickMoreThanOneText: showCanPickMoreThanOne = true,
  isMandatoryQuestion = false,
  questionId = 0,
}: EditTagsQuestionProps) => {
  const [selectedTags, setSelectedTags] = useState<number[]>(
    selectedTagsValue ?? []
  );
  const [maxAnswers, setMaxAnswers] = useState<number>(questionMaxAsnwer);
  const [minAnswers, setMinAnswers] = useState<number>(questionMinAsnwer);

  const enabled = selectedTags.length >= minAnswers;

  const handleSubmit = async (
    event: React.FormEvent<HTMLFormElement>,
    defaultValue = false
  ) => {
    event.preventDefault();
    onSave(defaultValue ? [NotRelevantTag.NOT_RELEVANT] : selectedTags);
  };

  const addTag = (tag: number) => {
    if (questionId === 15) {
      setSelectedTags([...selectedTags, tag]);
    } else {
      if (selectedTags.length < maxAnswers) {
        setSelectedTags([...selectedTags, tag]);
      } else {
        NiceModal.show("action_modal", {
          onNext: () => NiceModal.hide("action_modal"),
          headerTitle: "הגעת למקסימום",
          contentTitle: `אפשר לבחור עד ${questionMaxAsnwer} תכונות`,
          seconderyButtonText: "בהזדמנות אחרת",
          primaryButtonText: "בואו נמשיך",
          showCloseButton: false,
          showSeconderyButton: false,
          isWelcomeModal: false,
        });
      }
    }
  };

  const removeTag = (toRemove: number) =>
    setSelectedTags([
      ...selectedTags.filter((tagId: number) => tagId !== toRemove),
    ]);

  useEffect(() => {
    setSelectedTags(selectedTagsValue ?? []);
    setMaxAnswers(questionMaxAsnwer);
    setMinAnswers(questionMinAsnwer);
  }, [questionMaxAsnwer, questionMinAsnwer, selectedTagsValue]);

  console.log("22222");

  return (
    <>
      <div
        className="content_sec wf-section"
        style={{ paddingBottom: "100px" }}
      >
        <div className="signup_top_info">
          <div className="icon_info">
            <img
              src="~/assets/images/ic_info_smoke.svg"
              loading="lazy"
              alt=""
            />
          </div>
          <h2 className="signup_title">
            {questionId === 15 ? "סטטוס זוגי" : title}
          </h2>
          <div>{subtitle}</div>
          {showCanPickMoreThanOne && <div>אפשר לבחור יותר מאפשרות אחת</div>}
        </div>
        <div className="login_sec w-form">
          <form onSubmit={handleSubmit}>
            <div className="form_field_content login">
              <div className="form_links_group signup">
                {tags.map((tag, key) => {
                  const { text, value } = tag;
                  const isSelected = selectedTags.includes(value);
                  const onPress = () =>
                    isSelected ? removeTag(value) : addTag(value);
                  return <Tag {...{ text, key, onPress, isSelected }} />;
                })}
              </div>

              {isMandatoryQuestion ? (
                <div className="form_send_group">
                  <div className="form_buttons_group signup">
                    <input
                      type="submit"
                      value={buttonText}
                      data-wait=""
                      className={`button w-button ${
                        enabled
                          ? "button_full w-button"
                          : "button_full inactive  w-button"
                      }`}
                      disabled={!enabled}
                    />
                  </div>
                </div>
              ) : (
                <div className="form_send_group">
                  <div className="form_buttons_group filtering">
                    <input
                      disabled={!enabled}
                      value={buttonText}
                      type="submit"
                      defaultValue="המשך"
                      data-wait=""
                      className={`button filtering w-button`}
                    />
                    {skipButtonLink && (
                      <a
                        href="#"
                        onClick={(e: any) => {
                          setSelectedTags([]);
                          handleSubmit(e, true);
                        }}
                        className="skip_link"
                      >
                        {skipButtonLink}
                      </a>
                    )}
                  </div>
                </div>
              )}

              <br />
              <br />
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default EditTagsQuestion;
